export default __webpack_public_path__ + "static/media/credenciadoWeb.d8992b11.gif";